<template>
  <v-layout row justify-center>
    <v-dialog v-model="windowVisible" persistent max-width="600px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>Copy Hedge Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="close"><v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <kendo-dropdownlist
                  style="width:100%"
                  :data-source="dataSource"
                  :data-text-field="'name'"
                  :data-value-field="'clientId'"
                  :filter="'contains'"
                  :options-label="'Copy From'"
                  v-model="firstClientId"
                >
                </kendo-dropdownlist>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="currentClient" label="To" disabled></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue primary" @click="save">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'

export default {
  name: 'CopyPeriods',
  props: {
    windowVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        data: [],
        schema: {
          model: {
            fields: {
              clientId: {type: 'number'},
              name: {type: 'string'},
            },
          },
        },
      }),
      clients: [],
      firstClientId: 0,
      currentClient: 'Foo',
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  watch: {
    windowVisible(newValue) {
      if (newValue) this.getClients()
    },
  },
  methods: {
    close() {
      this.clients = []
      this.$emit('close')
    },
    getClients: async function() {
      const req = await axios
        .get('/api/config/client/getClientsWithHedgeTypes', {
          params: {
            clientId: this.clientId,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error getting data'))
      let data = req.data
      this.clients = data.clients
      this.dataSource.data(this.clients)
      this.currentClient = data.currentClient
      this.firstClientId = data.clientId
    },
    save: function() {
      axios
        .post('/api/config/client/copyHedgeTypes', {
          clientId: +this.clientId,
          fromClientId: +this.firstClientId,
        })
        .then(response => {
          if (response.status == 200) {
            this.$emit('save')
            let responseType = response.headers['content-type']
            if (responseType.includes('application/json')) {
              let parseResponse = response.data
              if (parseResponse.message) {
                notification(parseResponse.message)
              }
            }
            this.close()
          }
        })
        .catch(() => notification('Error saving', 'error'))
    },
  },
}
</script>

<style></style>
